export default __webpack_public_path__ + "static/media/PrgmH.7774b188.png";